import React from 'react';
import { Button, FormGroup, HelpBlock, Image, Panel } from 'react-bootstrap';
import { Field } from 'react-final-form';
import { Link } from '../Link.jsx';
import FieldGroup from '../FieldGroup.jsx';

const AcceptInvitationForm = (props) => (
  <Panel>
    <Panel.Body>
      <Link route="index">
        <a title="Sign in">
          <Image
            alt="ChangeSync Logo"
            className="component-margin-bottom"
            src="/static/images/logo.svg"
            responsive
          />
        </a>
      </Link>
      <p className="component-margin-bottom text-center">
        Accept your invitation to ChangeSync by setting a password for your new
        account.
      </p>
      <form onSubmit={props.handleSubmit}>
        <Field
          id="password"
          name="password"
          label="Password"
          type="password"
          component={FieldGroup}
        />
        <Field
          id="passwordConfirmation"
          name="passwordConfirmation"
          label="Confirm Password"
          type="password"
          component={FieldGroup}
        />
        {props.submitFailed && (
          <FormGroup validationState="error">
            <HelpBlock>{props.submitError}</HelpBlock>
          </FormGroup>
        )}
        <Button
          block
          bsSize="lg"
          bsStyle="primary"
          disabled={props.submitting}
          type="submit"
        >
          {props.submitting ? 'Setting Password...' : 'Set Password'}
        </Button>
      </form>
    </Panel.Body>
  </Panel>
);

export default AcceptInvitationForm;
